export const initialState = {
    answer: '1',
    msgs: [],
    question: '1',
    route: [],
    theme: 'top',
};
